export default __webpack_public_path__ + "static/media/contact.8fd9a39e.svg";